import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'smatchy-highlight-end-text',
  templateUrl: './highlight-end-text.component.html',
  styleUrls: ['./highlight-end-text.component.scss'],
  standalone: false,
})
export class HighlightEndTextComponent implements OnInit {
  @Input() mode: 'start' | 'end' | 'end-end' = 'end';
  @Input() width = '23';
  @Input() height = '24';

  constructor() {}

  ngOnInit() {}
}
